import React, { useState } from "react";
import styles from "./AnimalTable.module.css";

interface ProductData {
  key: number;
  region: string;
  counts: Record<string, number>;
}

const regions = [
  "Чуйская",
  "Ошская",
  "Нарынская",
  "Баткенская",
  "Таласская",
  "Иссык-Кульская",
  "Джалал-Абадская",
] as const;

const product = ["Молоко", "Шерсть", "Яйца", "Мясо"] as const;

const dataSource: ProductData[] = [
  {
    key: 0,
    region: "Чуйская",
    counts: {
        Молоко: 462,
        Шерсть: 1809,
        Яйца: 455,
        Мясо: 57,
    },
  },
  {
    key: 1,
    region: "Баткенская",
    counts: {
        Молоко: 101,
        Шерсть: 602,
        Яйца: 21,
        Мясо: 17,
    },
  },
  {
    key: 2,
    region: "Ошская",
    counts: {
        Молоко: 347,
        Шерсть: 2220,
        Яйца: 69,
        Мясо:51,
    },
  },
  {
    key: 3,
    region: "Таласская",
    counts: {
        Молоко: 77,
        Шерсть: 1500,
        Яйца: 23,
        Мясо: 14,
    },
  },
  {
    key: 4,
    region: "Нарынская",
    counts: {
        Молоко: 141,
        Шерсть: 2408,
        Яйца: 8.2,
        Мясо: 33.7,
    },
  },
  {
    key: 5,
    region: "Ыссык-Кульская",
    counts: {
        Молоко: 270,
        Шерсть: 1949,
        Яйца: 29.4,
        Мясо: 37.5,
    },
  },
  {
    key: 6,
    region: "Джалал-Абадская",
    counts: {
        Молоко: 372.9,
        Шерсть: 2396,
        Яйца: 77.1,
        Мясо: 16.5,
    },
    
  },

];

export const ProductOFmainTable: React.FC = () => {
  const [selectedProduct, setSelectedProduct] = useState<typeof product[number]>(
    product[0]
  );

  const handleProductChange = (
    event: React.ChangeEvent<HTMLSelectElement>
  ) => {
    setSelectedProduct(event.target.value as typeof product[number]);
  };

  return (
    <div className={styles.container}>
      <div className={styles.container_inner}>
      <h2>Производство по областям (Тыс/Тонн)</h2>
      <select
        value={selectedProduct}
        onChange={handleProductChange}
        className={styles.select}
      >
        {product.map((product) => (
          <option key={product} value={product}>
            {product}
          </option>
        ))}
      </select>

      <ul className={styles.table}>
        <li className={styles.header}>
          <span className={styles.cell}>Область</span>
          <span className={styles.cell}>{selectedProduct}</span>
        </li>
        {dataSource.map((item) => (
          <li key={item.key} className={styles.row}>
            <span className={styles.cell}>{item.region}</span>
            <span className={styles.cell}>{item.counts[selectedProduct]}</span>
          </li>
        ))}
      </ul>
      </div>
    </div>
  );
};


